import { memo } from 'react';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

interface Props {
  selected: boolean;
  value: string;
  availableOptions?: Record<string, number>;
  showCounts: boolean;
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface OptionCheckboxProps {
  selected: boolean;
}

function OptionCheckbox({ selected }: Readonly<OptionCheckboxProps>) {
  return <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />;
}

export const EntityAutocompletePickerOption = memo((props: Props) => {
  const { selected, value, availableOptions, showCounts } = props;
  const label = showCounts ? `${value} (${availableOptions?.[value]})` : value;

  return (
    <FormControlLabel
      control={<OptionCheckbox selected={selected} />}
      label={label}
      onClick={event => event.preventDefault()}
    />
  );
});
